import { render, staticRenderFns } from "./Dealer.vue?vue&type=template&id=57d993a9&scoped=true"
import script from "./Dealer.vue?vue&type=script&lang=js"
export * from "./Dealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d993a9",
  null
  
)

export default component.exports